import { OrderWithPartialLines } from 'src/redux/reducers/orders'
import { AccountFragment, Amount } from 'src/graphql'
import creditCardRequired from './creditCardRequired'

const creditCardNeeded = (
  order: OrderWithPartialLines,
  account: Pick<AccountFragment, 'stripeSource' | 'points' | 'expense'>,
  credits: Amount,
  isUsingCredits: boolean,
) =>
  creditCardRequired(order, account, credits, isUsingCredits) &&
  !account.stripeSource

export default creditCardNeeded
